import axios from 'axios';

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
  // Send the HttpOnly refresh cookie on the cross-origin auth calls (login / refresh / logout) so reload
  // re-establishment (FEATURE_005) works. The cookie is path-scoped to /api/v1/medical/auth server-side.
  withCredentials: true,
});
